module.exports = __webpack_public_path__ + "img/btn/button-secondary-hover.png";


//////////////////
// WEBPACK FOOTER
// ./img/btn/button-secondary-hover.png
// module id = 49
// module chunks = d-game